import { render, staticRenderFns } from "./MyButton.vue?vue&type=template&id=1324b3b4&scoped=true"
import script from "./MyButton.vue?vue&type=script&lang=js"
export * from "./MyButton.vue?vue&type=script&lang=js"
import style0 from "./MyButton.vue?vue&type=style&index=0&id=1324b3b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1324b3b4",
  null
  
)

export default component.exports